function Portugal({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1931)">
  <path d="M0 16.0009C0 22.8803 4.342 28.745 10.4347 31.0057L11.8261 16.0008L10.4347 0.996094C4.342 3.25684 0 9.12147 0 16.0009Z" fill="#6DA544"/>
  <path d="M32 16C32 7.1635 24.8365 0 16 0C14.0429 0 12.1681 0.352063 10.4347 0.995188V31.0048C12.1681 31.648 14.0429 32 16 32C24.8365 32 32 24.8365 32 16Z" fill="#D80027"/>
  <path d="M10.4348 21.5659C13.5084 21.5659 16 19.0743 16 16.0007C16 12.9272 13.5084 10.4355 10.4348 10.4355C7.36125 10.4355 4.86963 12.9272 4.86963 16.0007C4.86963 19.0743 7.36125 21.5659 10.4348 21.5659Z" fill="#FFDA44"/>
  <path d="M7.30432 13.2168V16.695C7.30432 18.4239 8.70582 19.8255 10.4348 19.8255C12.1637 19.8255 13.5652 18.424 13.5652 16.695V13.2168H7.30432Z" fill="#D80027"/>
  <path d="M10.4349 17.7394C9.85948 17.7394 9.39136 17.2713 9.39136 16.6959V15.3047H11.4783V16.696C11.4783 17.2713 11.0102 17.7394 10.4349 17.7394Z" fill="#F0F0F0"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Portugal;
